import { applyMiddleware, combineReducers, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'

import thunk from 'redux-thunk'

import reducer from './reducers'

const rootReducer = combineReducers({ reducer })

export default createStore(
	rootReducer,
	composeWithDevTools({
		trace: true, // Add this line to enable trace
	})(applyMiddleware(thunk)),
)
